var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgByPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189:127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0651 47.2992H33.6967C34.3496 47.2992 34.8809 46.7524 34.8809 46.0804V22.5179C34.8809 21.846 34.3496 21.2992 33.6967 21.2992H21.0651C20.4122 21.2992 19.8809 21.846 19.8809 22.5179V46.0804C19.8809 46.7524 20.4122 47.2992 21.0651 47.2992ZM20.6704 22.5179C20.6704 22.4102 20.712 22.3069 20.786 22.2307C20.86 22.1545 20.9604 22.1117 21.0651 22.1117H33.6967C33.8014 22.1117 33.9018 22.1545 33.9758 22.2307C34.0499 22.3069 34.0914 22.4102 34.0914 22.5179V46.0804C34.0914 46.1882 34.0499 46.2915 33.9758 46.3677C33.9018 46.4439 33.8014 46.4867 33.6967 46.4867H21.0651C20.9604 46.4867 20.86 46.4439 20.786 46.3677C20.712 46.2915 20.6704 46.1882 20.6704 46.0804V22.5179Z",
    fill: "url(#paint0_radial_189:127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8546 43.2367H32.9072C33.0119 43.2367 33.1123 43.1939 33.1864 43.1177C33.2604 43.0415 33.302 42.9382 33.302 42.8304V25.7679C33.302 25.6602 33.2604 25.5569 33.1864 25.4807C33.1123 25.4045 33.0119 25.3617 32.9072 25.3617H21.8546C21.7499 25.3617 21.6495 25.4045 21.5755 25.4807C21.5015 25.5569 21.4599 25.6602 21.4599 25.7679V42.8304C21.4599 42.9382 21.5015 43.0415 21.5755 43.1177C21.6495 43.1939 21.7499 43.2367 21.8546 43.2367ZM22.2493 26.1742H32.5125V42.4242H22.2493V26.1742Z",
    fill: "url(#paint1_radial_189:127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7756 45.6742C28.2117 45.6742 28.5651 45.3104 28.5651 44.8617C28.5651 44.413 28.2117 44.0492 27.7756 44.0492C27.3396 44.0492 26.9862 44.413 26.9862 44.8617C26.9862 45.3104 27.3396 45.6742 27.7756 45.6742Z",
    fill: "url(#paint2_radial_189:127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.802 24.5492H28.9599C29.0645 24.5492 29.165 24.5064 29.239 24.4302C29.313 24.354 29.3546 24.2507 29.3546 24.1429C29.3546 24.0352 29.313 23.9319 29.239 23.8557C29.165 23.7795 29.0645 23.7367 28.9599 23.7367H25.802C25.6973 23.7367 25.5969 23.7795 25.5228 23.8557C25.4488 23.9319 25.4072 24.0352 25.4072 24.1429C25.4072 24.2507 25.4488 24.354 25.5228 24.4302C25.5969 24.5064 25.6973 24.5492 25.802 24.5492V24.5492Z",
    fill: "url(#paint3_radial_189:127)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_189:127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.611 30.906C26.1944 31.0208 25.7805 31.1457 25.3699 31.2805C25.3324 31.2926 25.299 31.315 25.2737 31.3452C25.2483 31.3754 25.2319 31.4121 25.2264 31.4511C24.984 33.2698 25.544 34.5967 26.212 35.4708C26.4949 35.8446 26.8322 36.1739 27.2126 36.4478C27.364 36.5545 27.4979 36.6315 27.6033 36.681C27.6558 36.7059 27.6987 36.7225 27.7315 36.7326C27.7458 36.7376 27.7606 36.7413 27.7757 36.7435C27.7905 36.7411 27.8052 36.7374 27.8194 36.7326C27.8527 36.7225 27.8955 36.7059 27.948 36.681C28.053 36.6315 28.1874 36.5541 28.3387 36.4478C28.7192 36.1739 29.0564 35.8446 29.3393 35.4708C30.0074 34.5971 30.5674 33.2698 30.325 31.4511C30.3195 31.412 30.3031 31.3753 30.2777 31.3451C30.2524 31.315 30.219 31.2926 30.1815 31.2805C29.8967 31.1873 29.4159 31.0355 28.9403 30.9064C28.4547 30.7747 28.008 30.6771 27.7757 30.6771C27.5438 30.6771 27.0967 30.7747 26.611 30.9064V30.906ZM26.4947 30.4553C26.9694 30.3263 27.4738 30.2103 27.7757 30.2103C28.0775 30.2103 28.582 30.3263 29.0567 30.4553C29.5423 30.5866 30.0319 30.7419 30.3197 30.836C30.4401 30.8757 30.5468 30.9486 30.6276 31.0463C30.7084 31.1439 30.76 31.2624 30.7765 31.3881C31.0372 33.3468 30.4322 34.7984 29.698 35.7587C29.3867 36.1695 29.0155 36.5313 28.5969 36.8319C28.4521 36.9359 28.2987 37.0274 28.1384 37.1053C28.0159 37.1631 27.8842 37.2103 27.7757 37.2103C27.6672 37.2103 27.5359 37.1631 27.413 37.1053C27.2526 37.0274 27.0993 36.9359 26.9545 36.8319C26.5358 36.5313 26.1646 36.1695 25.8533 35.7587C25.1192 34.7984 24.5141 33.3468 24.7749 31.3881C24.7913 31.2624 24.8429 31.1439 24.9237 31.0463C25.0045 30.9486 25.1112 30.8757 25.2316 30.836C25.6495 30.6989 26.0706 30.572 26.4947 30.4553V30.4553Z",
    fill: "url(#paint4_radial_189:127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0243 32.4617C29.0447 32.482 29.0608 32.5062 29.0719 32.5328C29.0829 32.5593 29.0886 32.5878 29.0886 32.6166C29.0886 32.6454 29.0829 32.6739 29.0719 32.7004C29.0608 32.727 29.0447 32.7512 29.0243 32.7715L27.7118 34.084C27.6915 34.1043 27.6673 34.1205 27.6408 34.1315C27.6142 34.1426 27.5857 34.1482 27.5569 34.1482C27.5281 34.1482 27.4997 34.1426 27.4731 34.1315C27.4465 34.1205 27.4224 34.1043 27.402 34.084L26.7458 33.4277C26.7255 33.4074 26.7093 33.3832 26.6983 33.3567C26.6873 33.3301 26.6816 33.3016 26.6816 33.2729C26.6816 33.2441 26.6873 33.2156 26.6983 33.189C26.7093 33.1625 26.7255 33.1383 26.7458 33.118C26.7661 33.0976 26.7903 33.0815 26.8168 33.0705C26.8434 33.0595 26.8719 33.0538 26.9007 33.0538C26.9294 33.0538 26.9579 33.0595 26.9845 33.0705C27.0111 33.0815 27.0352 33.0976 27.0555 33.118L27.5569 33.6198L28.7145 32.4617C28.7349 32.4414 28.759 32.4252 28.7856 32.4142C28.8122 32.4031 28.8406 32.3975 28.8694 32.3975C28.8982 32.3975 28.9267 32.4031 28.9533 32.4142C28.9798 32.4252 29.004 32.4414 29.0243 32.4617V32.4617Z",
    fill: "url(#paint5_radial_189:127)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15353,
    y: 1.0448,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint6_radial_189:127)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6309 46.1521) rotate(-74.282) scale(32.5709 21.5551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4204 42.4481) rotate(-72.0908) scale(22.6528 16.8216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3809 45.6025) rotate(-64.64) scale(2.16853 2.12995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3941 24.5133) rotate(-22.8777) scale(2.52023 2.29089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2444 36.9015) rotate(-66.8858) scale(9.17794 8.40956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2834 34.071) rotate(-56.1535) scale(2.54203 2.98419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_189:127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1422 61.2791) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189:127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 26,
    fill: "white",
    transform: "translate(19.8809 21.2992)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_189:127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(24.2757 30.2103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByPhoneIcon);
export default __webpack_public_path__ + "static/media/by_phone_icon.57c591eb.svg";
export { ForwardRef as ReactComponent };